export { default as ArrowsIcon } from "./ArrowsIcon";
